import { useEffect, useState } from 'react';
import NBXAuth from 'services/auth.service';

export default function useOAuthAccounts(firebaseToken, orgId) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOAuthAccounts = async () => {
      const accounts = await NBXAuth.oAuthAccounts(firebaseToken, orgId);
      const accountsOptions = accounts.map(({ id, name }) => ({ value: id, label: name }));
      setOptions(accountsOptions);
      setLoading(false);
    };
    loadOAuthAccounts();
  }, [firebaseToken, orgId]);

  useEffect(() => {
    if (options.length === 1) setSelected(options[0].value);
  }, [options]);

  return { options, selected, setSelected, loading };
}
